module.exports = "<div id={{$ctrl.cbName}}><div uib-carousel active=$ctrl.active interval=$ctrl.myInterval><div uib-slide ng-repeat=\"item in $ctrl.cbItems\" index=$index><a href=\"{{item.url ? item.url : '#'}}\" title={{item.title}}><img ng-src={{item.imageUrl}} target=\"{{item.url ? '_blank': '_self'}}\" style=margin:auto></a><div class=carousel-caption></div></div></div></div>";


/*****************
 ** WEBPACK FOOTER
 ** ./www/components/shared/components/banners/carousel-banner/carousel-banner.view.html
 ** module id = 506
 ** module chunks = 8
 **/